import { k as C, j as I, t as p, N as O, _ as $ } from "./export-cdcbfb2b.js";
import { f as y, i as A } from "./es.object.to-string-f55666a8.js";
import { i as b, a as x, g as j, b as k } from "./iterate-13ada9e5.js";
import { c as M } from "./create-property-f9780ed1.js";
import { c as R } from "./check-correctness-of-iteration-7d57c70c.js";
var T = C, N = b, S = function(o, n, t, i) {
  try {
    return i ? n(T(t)[0], t[1]) : n(t);
  } catch (s) {
    N(o, "throw", s);
  }
}, _ = y, w = I, L = p, E = S, P = x, W = A, B = O, g = M, F = j, U = k, d = Array, q = function(n) {
  var t = L(n), i = W(this), s = arguments.length, e = s > 1 ? arguments[1] : void 0, h = e !== void 0;
  h && (e = _(e, s > 2 ? arguments[2] : void 0));
  var m = U(t), r = 0, f, a, l, v, u, c;
  if (m && !(this === d && P(m)))
    for (a = i ? new this() : [], v = F(t, m), u = v.next; !(l = w(u, v)).done; r++)
      c = h ? E(v, e, [l.value, r], !0) : l.value, g(a, r, c);
  else
    for (f = B(t), a = i ? new this(f) : d(f); f > r; r++)
      c = h ? e(t[r], r) : t[r], g(a, r, c);
  return a.length = r, a;
}, z = $, D = q, G = R, H = !G(function(o) {
  Array.from(o);
});
z({ target: "Array", stat: !0, forced: H }, {
  from: D
});
export {
  q as a
};
